import { Modal, Tag } from 'antd'
import { DownloadFileModal } from 'components/DownloadFile'
import SearchBar from 'components/SearchBar'
import React, { useState } from 'react'
import { useRef } from 'react'
import menus, { TrainAnnexFile, TrainModule } from './menus'
import './train.less'

const TrainCom = () => {
  const [currentMenu, setCurrentMenu] = useState(0)
  const [modalVisible, setVisible] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')
  const trainVideoRef = useRef<HTMLVideoElement | null>(null)



  //点击目录中某项进行页面开始滑动
  const handleScrollTo = (id: string) => {
    const el = document.getElementById(id)
    const itemOffsetHeight = el?.offsetTop
    window.scrollTo({
      top: itemOffsetHeight,
      behavior: 'smooth'
    })
  }

  // 开启弹窗
  const openVideoModal = (url: string) => {
    setVideoUrl(url)
    setVisible(true)
  }

  // 关闭弹窗
  const closeVideoModal = () => {
    trainVideoRef.current?.pause()
    setVisible(false)
  }


  // 随机颜色
  const randomColor = (index: number) => {
    let colors = ["pink", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "red", "gold", "lime"]
    return colors[(index % colors.length)]
  }

  // 视频
  const renderTrainVideo = (videos: TrainAnnexFile[]) => {
    let currentSort = ""
    let hasSort = false
    if (videos[0].sort) {
      hasSort = true
    }

    return (
      < div className={`train-video-card-container`}>
        {

          videos.map((video, index) => {
            let needSort = false
            if (hasSort && video.sort !== currentSort) {
              needSort = true
              currentSort = video.sort!
            }

            return (
              <>
                {needSort ? <div style={{ width: '100%' }}><Tag className='sort-title' color={randomColor(index)} >{currentSort}</Tag>
                </div> : ''}

                <div key={index}>
                  <div className="train-video-card" onClick={() => openVideoModal(video.url)}>
                    <img src={video.image} alt="video-cover" className="train-video-image" />
                    <div className="train-video-card-mask"></div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/train-video-icon.png`}
                      className="train-video-icon"
                      alt="video-icon"
                    />
                  </div>
                  <div className="train-video-card-title">{video.name}</div>
                </div>
              </>
            )
          }
          )}
      </div >
    )

  }

  // 主体内容
  const renderTrainContent = (ms: TrainModule[]) => {
    // ms     2层循环
    // menu   依次循环(3，有多少层循环多少层)   
    // index  下标
    return (
      <div>
        {
          ms.map((menu, index) => (
            <div
              key={index}
              id={menu.id}
              className={`train-container-inner ${(menu.level === 1 && currentMenu !== index) ? 'hide' : ''}`}
            >
              {/* 标题 */}
              {
                menu.level === 1 ? "" :
                  <div className={`title bold train-title-${menu.level}`}>
                    {menu.level === 3 ? index + 1 + ". " : ''}{menu.name}
                  </div>
              }
              {/* 顶部文字介绍 */}
              {
                menu.desc ? <div className="train-desc second-title">{menu.desc}</div> : ""
              }
              {/* 二级菜单*/}
              {menu.subs ? renderTrainContent(menu.subs) : ''}
              {
                menu.videos ? renderTrainVideo(menu.videos!) : ''
              }
              {
                menu.docs ? renderDocs(menu.docs!) : ''
              }
            </div>
          ))
        }
      </div >
    )

  }

  // 文档
  const renderDocs = (docs: TrainAnnexFile[]) => {

    return (
      <div className="train-document-group">
        {docs.map((annex, index) => (
          <div
            className="second-title train-document"
            key={index}
            onClick={() => {
              if (annex.type === 'link') {
                window.open(annex.url)
              } else {
                console.log("trigger download");

                setDownloadName(annex.name)
                setDownloadSuffix(annex.suffix!)
                console.log(annex.url);
                console.log(annex.url.substring(52));

                setDownloadUrl(annex.url.substring(52))
                setDownloading(true)
              }
            }
            }
          >
            {index + 1 + '.' + annex.name}{annex.suffix ? '.' + annex.suffix : ""}
          </div>
        ))}
      </div>
    )
  }

  // 左侧导航
  const renderTrainNav = (menu: TrainModule, index: number) => {
    // 体系，教研，示范课没有nav属性( nav: true,)
    if (!menu.nav) {
      return ""
    }
    return (
      <div key={index} className={`${currentMenu === index ? 'train-catalogue' : 'hide'}`}>
        {menu.subs?.map((sub, index) => (
          // 一重循环  
          // 左侧导航》一级标题
          <div className="train-catalogue-group" key={index}>
            <div className="bold train-catalogue-header" onClick={() => handleScrollTo(sub.id!)}  >{sub.name}</div>
            {/* 二重循环 */}
            {/*左侧导航》二级标题  */}
            <div className="train-catalogue-content">
              {sub.subs?.map((product, index) => {
                //路径 product  menus>subs>subs>{}       
                return (
                  <div
                    className="train-catalogue-item small"
                    key={index}
                    onClick={() => handleScrollTo(product.id!)}
                  >
                    {index + 1}、{product.name}
                  </div>
                )

              })}
            </div>
          </div>
        ))}
      </div>
    )


  }
  const [downloadName, setDownloadName] = useState("")
  const [downloadSuffix, setDownloadSuffix] = useState("")
  const [downloadUrl, setDownloadUrl] = useState("")
  const [downloading, setDownloading] = useState(false)

  //  页面主体
  return (
    <>
      <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/train-banner.png)` }}>
        <SearchBar module="Teacher Training" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        {/* 顶部tab标签栏 */}
        <div className="train-tab-container">
          {menus.map((menu, index) => (
            // 顶部单个tab标签
            <div
              key={index}
              className={`train-tab second-title bold ${currentMenu === index ? 'train-tab-active' : ''
                }`}
              onClick={() => { setCurrentMenu(index) }}
            >
              {menu.name}
            </div>
          ))}
        </div>
        <div className="train-catalogue-outer">
          {/* 产品目录 */}
          {menus.map((menu, index) => renderTrainNav(menu, index))}
          {/* 产品内容 */}
          <div className="train-container">
            {renderTrainContent(menus)}
          </div>
        </div>
      </div>
      {/* 下载弹窗 */}
      <DownloadFileModal name={downloadName} suffix={downloadSuffix} url={downloadUrl} downloading={downloading} setDownloading={setDownloading} />

      {/* 视频弹窗 */}
      <Modal
        width={1200}
        className="video-modal"
        footer={null}
        visible={modalVisible}
        onCancel={closeVideoModal}
        maskClosable={false}
      >
        <video
          controls
          style={{ width: '100%', height: '100%', outline: 'none' }}
          src={videoUrl}
          ref={trainVideoRef}
        ></video>
      </Modal>
    </>
  )
}

export default TrainCom
